import { Alert, AlertTitle } from "@material-ui/lab";
import React from "react";
import { useField } from "react-final-form";

const UnassignedLocationsWarningAlert = () => {
  const desiredRouteDurationField = useField("desiredRouteDuration");
  const maxVehicleCapacityField = useField("maxVehicleCapacity");
  const maxStopTimeField = useField("maxStopTime");

  return (
    <>
      <Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        The system cannot optimize some locations due to the current
        constraints:
        <ul style={{ fontWeight: 600, margin: 5 }}>
          <li>
            Maximum vehicle capacity: {maxVehicleCapacityField.input.value}
          </li>
          <li>Maximum stop time: {maxStopTimeField.input.value} m</li>
          <li>
            Desired route duration: {desiredRouteDurationField.input.value} m
          </li>
        </ul>
        You can increase the{" "}
        <span style={{ fontWeight: 600 }}>maximum vehicle capacity</span> or
        extend the <span style={{ fontWeight: 600 }}>route duration</span> or{" "}
        <span style={{ fontWeight: 600 }}>stop time</span> until all locations
        are successfully assigned to the routes. Alternatively, you can manually
        assign any unassigned locations using the table below.
      </Alert>
    </>
  );
};

export default UnassignedLocationsWarningAlert;
